import { useMemo, useState } from 'react';
import {
  getNextSortDirection,
  sortRows,
} from '../../../../../utils/tableUtils';

function useTableSort(rows, comparators, initialSort = {}) {
  const [order, setOrder] = useState(initialSort.order || '');
  const [orderBy, setOrderBy] = useState(initialSort.orderBy || '');

  const sortedRows = useMemo(
    () => sortRows(rows, orderBy, order, comparators),
    [comparators, order, orderBy, rows]
  );

  const handleRequestSort = (field) => {
    setOrder(getNextSortDirection(orderBy, order, field));
    setOrderBy(field);
  };

  return {
    order,
    orderBy,
    sortedRows,
    handleRequestSort,
  };
}

export default useTableSort;
